import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class WebsiteService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

  getMenuMechanics(){
    let url = 'public/get_mechanics_menu';
      return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
  }

  getMechanicsDetails(id){
    let url = 'public/get_mechanics_details?id='+ id;
      return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
  }

    getItems(filter,maxItemsPerPage = 10,last_id = 0){
        // maxItemsPerPage = 10, page=1
         let url = 'public/get_items?last_id=' + last_id + '&maxItemsPerPage=' + maxItemsPerPage

        //let url = 'public/get_items'
        return this.http.post(this.BASE_URL_API + url,filter,this.storage.getHeaders())
        
    }

    getItemDropdown(){
      let url = 'public/get_item_dropdown';
      return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
      }

      getItemDetail(item_id,utms:any){
        let url = 'public/get_item_details?item_id=' + item_id + '&utm_medium=' + utms['utm_medium'] + '&utm_source=' + utms['utm_source'] + '&utm_campaign=' + utms['utm_campaign'] + '&utm_content=' + utms['utm_content']
        return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
      }
    
  

    //   saveItems(item:any){
    //     let url = 'save_items'
    //     return this.http.post(this.BASE_URL_API + url,item,this.storage.getHeaders())
    //   }

    //   getItemDropdowns(){
    //     let url = 'get_item_dropdown'
    //     return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
    //   }


}
